import { render } from "./alarms.vue?vue&type=template&id=216f3165"
import script from "./alarms.vue?vue&type=script&lang=js"
export * from "./alarms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__